import {
    LOAD_USER,
    USER_LOADING,
    USER_MODAL_LOADING,
    USER_STOP,
    USER_ORDERS,
    USER_SEARCH,
    USER_SEARCH_CLEAR,
    USER_SEARCH_UPDATE,
    SPOD_SUCCESS,
    SPOD_ERR,
    USER_EXPORT,
    USER_EXPORT_SUCCESS,
    USER_CLOSE_ALERT, TABLE_LOADING
} from "../type";
import {GridRowsProp} from "@mui/x-data-grid/models/gridRows";

const initialState = {
    isLoading: false,  // table use
    TableLoading: false,  // 页面表格加载
    ModalLoading: false,  // modal use
    pageSize: 30,
    page: 0,
    rowCount: 0,
    display: true,
    search: null,
    searchClick: false,
    data: [],
    stop: true,
    orderClick: false,
    orders: [],
    alert: false,

    // 功能性模块参数
    preview_pdf_url: "",
    preview_modal_open: false,


};

export default function (preState=initialState, action) {
    const {type, payload} = action
    switch (type) {
        case LOAD_USER:
            const rows : GridRowsProp = payload.data
            return {
                ...preState,
                data: rows,
                rowCount: payload.rowCount,
                TableLoading: false,
                page: payload.page,
                pageSize: payload.pageSize,
                request: false
            }
        case USER_LOADING:
            return {
                ...preState,
                TableLoading: true,
                data: []
            }
        case USER_MODAL_LOADING:
            return {
                ...preState,
                ModalLoading: true,
                // request: false,
                content: null,
            }
        case USER_STOP:
            return {
                ...preState,
                stop: false,
                searchClick: false,
                orderClick: false
            }
        case USER_ORDERS:
            return {
                ...preState,
                orderClick: true,
                orders: payload
            }
        case USER_SEARCH:
            return {
                ...preState,
                page: 0,
                pageSize: 30,
                stop: true,
                searchClick: true
            }
        case USER_SEARCH_CLEAR:
            return {
                ...preState,
                search: []
            }
        case USER_SEARCH_UPDATE:
            let search;
            if (!preState.search) {
                search = payload;
            } else {
                search = preState.search;
                for (let i in payload){
                    search[i] = payload[i]
                }
            }
            return {
                ...preState,
                search: search,
                searchClick: false
            }
        case USER_EXPORT:
            return {
                ...preState,
                isLoading: true
            }
        case USER_EXPORT_SUCCESS:
            return {
                ...preState,
                isLoading: false,
                alert: true,
                content: payload,
                search: {
                    ...preState.search,
                    submitType: ""
                }
            }
        case USER_CLOSE_ALERT:
            return {
                ...preState,
                alert: false
            }
        case SPOD_SUCCESS:
        case SPOD_ERR:
            return {
                ...preState,
                ModalLoading: false,
                request: true,
                alert: true,
                content: payload,
            }
        case TABLE_LOADING:
            return {
                data: [],
                TableLoading: true
            }
        default:
            return preState
    }
}